import React, { FC } from 'react';
import styles from './scopeThreeCategoryCard.module.scss';
import { ReactNode } from 'react';
import COBadge from '../COBadge';
import { BadgeColors } from 'enums/COBadgeEnums';
import clsx from 'clsx';
import { ScopeThreeCategoryStatusEnums } from 'enums/ScopeThreeCategoryStatusEnums';
import useRedirect from 'shared/utils/useRedirect';
import { generatePath, useParams } from 'react-router-dom';
import useFilters from 'shared/hooks/useFilters';
import { queryParamsList } from 'views/ActivityDataEntry';

interface ScopeThreeCategoryCardProps {
  icon: ReactNode;
  name: string;
  title: string;
  subHeading: string;
  status?: boolean;
  redirectRoute?: string;
  isProcessingFacility?: boolean;
}

const ScopeThreeCategoryCard: FC<ScopeThreeCategoryCardProps> = props => {
  const {
    icon,
    name,
    title,
    subHeading,
    status,
    redirectRoute,
    isProcessingFacility,
  } = props;
  const { DARKGREEN, RED, GREY } = BadgeColors;
  const { redirect } = useRedirect();
  const { id } = useParams();
  const { getParams } = useFilters();
  const { activeTab } = getParams(queryParamsList);
  const handleRedirect = () =>
    redirectRoute &&
    redirect({
      pathname: generatePath(redirectRoute, { id }),
      queryParams: { activeTab, isProcessingFacility },
      replace: true,
    });
  return (
    <div
      className={clsx(
        styles.cardContainer,
        status !== undefined && styles.activeCardContainer
      )}>
      <div className={styles.cardItem} onClick={handleRedirect}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.detailsContainer}>
          <div className={styles.name}>{name}</div>
          <div className={styles.title}>{title}</div>
          <div className={styles.subHeading}>{subHeading}</div>
          <div>
            <COBadge
              color={
                status === true ? DARKGREEN : status === false ? RED : RED // GREY
              }>
              {status === true
                ? ScopeThreeCategoryStatusEnums.COMPLETED
                : status === false
                  ? ScopeThreeCategoryStatusEnums.IN_COMPLETE
                  : ScopeThreeCategoryStatusEnums.IN_COMPLETE // COMING_SOON
              }
            </COBadge>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScopeThreeCategoryCard;
